import React from 'react';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

const TimezoneOptions = () => {
    return (
        strings.timezones.map((timezone, i) => <option key={i} value={timezone.name} class='js-timezone-option'>{timezone.name} - {timezone.abbreviation}</option>)
    )
}

export default TimezoneOptions;


// WEBPACK FOOTER //
// ./src/components/Common/TimezoneOptions/TimezoneOptions.js